<div *ngIf="isVisible" class="area-list left-first-level-container" [@openClose]>

    <!-- moded: dark theme when create component -->
    <div class="area-list__theme" [ngClass]="{'area-list__theme--dark': viewMode === ViewMode.Form }">

        <!-- header-->
        <div class="area-list__header">
            <span class="area-list__label">{{'labels.areas' | translate | titlecase}}</span>
            <div class="area-list__buttons">
                <div class="area-list__btn-close" [routerLink]="['/panel' , 'main']"></div>
            </div>
        </div>

        <!-- filter -->
        <div class="area-list__filter">
            <tk-area-list-filter [viewMode]="viewMode" (onHandleOnHeightChanged)="handleOnHeightChanged($event)">
            </tk-area-list-filter>
        </div>

    </div>

    <div class="area-list__block">

        <!-- create area -->
        <tk-area-create [goToDefinition]="selectedArea != null" [selectedAreaTypeSubject]="selectedAreaTypeSubject"
            (onCancel)="onCancel()"></tk-area-create>

        <!-- list -->
        <div *ngIf="viewMode === ViewMode.List" class="area-list__items">



            <div *ngIf="!areas" class="loading-areas">{{'labels.loading-data' | translate}}</div>
            <div *ngIf="areas && areas.length == 0" class="no-areas">
                <span class="msg-main">{{'labels.no-result' | translate}}</span>
            </div>


            <ng-container *ngIf="areas && areas.length > 0">


                <tk-scrolled-list id="area-lite-list" styleClass="loaded-areas" [itemHeight]="40" [items]="areas"
                    idFieldName="Id">
                    <ng-template #itemTemplate let-item>
                        <div (click)="onSelect(item)" [class.selected]="item.Id === selectedAreaId">
                            <tk-area-list-item [area]="item" [isSelected]="item.Id === selectedAreaId">
                            </tk-area-list-item>
                        </div>
                    </ng-template>
                </tk-scrolled-list>
                <!-- komponent scroll bar -->
                <tk-scroll-bar elementId="area-lite-list"></tk-scroll-bar>


            </ng-container>
        </div>

    </div>

    <!-- form -->
    <div *ngIf="viewMode === ViewMode.Form">
        <tk-area-form [area]="selectedArea!" [selectedAreaTypeSubject]="selectedAreaTypeSubject"
            (onSave)="onSave($event)" (onDelete)="onDelete($event)"></tk-area-form>
    </div>

</div>
